export default __webpack_public_path__ + "static/media/lost_prayer_to_the_sacred_winds.45f8ca2a.png";